<template>
  <div id="AccountExportEmails" class="Main-Content">
    
    <LoadingLayout v-if="loading" :page="true" />

    <Page
      v-else
      :title="$t('Export Emails')"
    >

      <LoadingLayout v-if="exporting" />
      <Layout v-else>
        <LayoutSection>
          <Card>
            <CardSection>
              <FormLayout>
                <FormLayoutGroup condensed>
                  <DatePicker
                    :label="$t('Start Date')"
                    :placeholder="$t('Start Date')"
                    v-model="filter.startDate"
                  />
                  <DatePicker
                    :label="$t('End Date')"
                    :placeholder="$t('No Restriction')"
                    v-model="filter.endDate"
                  />
                  <Select
                    :label="$t('Campaign')"
                    v-model="filter.campaignId"
                    :placeholder="$t('Select Campaign')"
                    :options="campaignOptions"
                  />
                  <Select
                    :label="$t('Status')"
                    v-model="filter.status"
                    :options="statusOptions"
                  />
                </FormLayoutGroup>
              </FormLayout>
            </CardSection>
          </Card>

          <Card v-if="loadingPreview">
            <CardSection>
              <SkeletonBodyText />
            </CardSection>
          </Card>

          <Card v-else :title="$t('AccountExportEmails.Export preview')">
            <CardSection v-if="previewItems.length === 0">
              <div v-if="!filter.campaignId">{{$t('AccountExportEmails.Choose a campaign and click preview')}}</div>
              <div v-else>{{$t('AccountExportEmails.No collected emails match your filters')}}</div>
            </CardSection>
            <CardSection v-else>
              <div style="margin-bottom: 15px;">{{$t('AccountExportEmails.emailsShownMessage', { total: `${counts.total}` })}}</div>
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th>{{$t('Email')}}</th>
                    <th>{{$t('Collected Time')}}</th>
                    <th>{{$t('Segments')}}</th>
                    <th>{{$t('Status')}}</th>
                    <th>{{$t('Campaign')}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="preview of previewItems" :key="preview.email">
                    <td>{{ preview.email }}</td>
                    <td>{{ preview.collectedTime }}</td>
                    <td>{{ preview.segments }}</td>
                    <td>{{ preview.isNew ? $t('New') : $t('Old') }}</td>
                    <td>{{ preview.campaignName }}</td>
                  </tr>
                </tbody>
              </table>
            </CardSection>
          </Card>

          <Card>
            <CardSection>
              <ButtonGroup>
                <Button @click="preview" :disabled="loadingPreview">{{$t('Update Preview')}}</Button>
                <Button type="primary" :disabled="previewItems.length === 0" @click="exportNow">{{$t('Export')}}</Button>
              </ButtonGroup>
            </CardSection>
          </Card>
        </LayoutSection>
      </Layout>

    </Page>
  </div>
</template>

<script>

import moment from 'moment'

export default {
  name: 'AccountExportEmails',
  data () {
    return {
      loading: true,
      loadingPreview: false,
      exporting: false,
      filter: {
        startDate: null,
        endDate: null,
        campaignId: null,
        status: 'new'
      },
      previewItems: [],
      counts: {
        total: 0,
        downloaded: 0
      },
      campaigns: []
    }
  },
  mounted() {

    this.filter.startDate = moment().startOf('month').format('YYYY-MM-DD 00:00:00')

    if (this.$route.query.campaignId) {
      this.filter.campaignId = this.$route.query.campaignId
    }

    // if (!this.filter.campaignId) {
    //   this.$watch('filter.campaignId', (newVal, oldVal) => {
    //     if (!oldVal && newVal) {
    //       this.preview()
    //     }
    //   })
    // }

    NProgress.start()
    this.api.getCampaignNames()
    .then((campaigns) => {
      this.campaigns = campaigns
      this.loading = false

      if (this.filter.campaignId) {
        this.preview()
      }
    })
    .catch(this.apiCatch)
    .finally(() => {
      NProgress.done()
    })
  },
  computed: {
    campaignOptions() {
      return [{
        label: this.$t('All'),
        value: ''
      }, 
      {
        label: '-',
        value: ''
      }].concat(this.campaigns.map(c => {
        return {
          label: c.name,
          value: c.id
        }
      }))
    },
    statusOptions() { 
      return [
        { label: this.$t('AccountExportEmails.New emails'), value: 'new' },
        { label: this.$t('AccountExportEmails.Previously downloaded emails'), value: 'downloaded' },
        { label: this.$t('AccountExportEmails.All emails'), value: 'all' }
      ]
    }
  },
  methods: {
    preview() {
      NProgress.start()
      this.loadingPreview = true

      this.api.getExportEmailsPreview(this.filter)
      .then((response) => {
        this.counts.total = response.total
        this.counts.downloaded = response.downloaded
        
        this.previewItems = response.emails

        this.loadingPreview = false
      })
      .catch(this.apiCatch)
      .finally(() => {
        NProgress.done()
      })
    },
    exportNow() {
      NProgress.start()
      this.exporting = true
      this.api.getExportEmailsUrl(this.filter)
        .then((response) => {
          if (response.file) {
            window.open(response.file)
          } else {
            this.eventHub.$emit('startBackgroundProcess')
          }
        })
        .catch(this.apiCatch)
        .finally(() => {
          this.exporting = false
          NProgress.done()
        })
    }
  }
}

</script>

<style lang="scss">
</style>
